import { useRecoilState, useRecoilValue } from 'recoil';
import { Button } from 'components/core';
import { builderAnswersState, builderEffectiveOutputState } from 'states';
import { importAdvanced } from 'helpers/kpiBuilder/advanced';
import { resolvedChart } from 'helpers/kpiBuilder/engine';
import { BuilderSection } from './BuilderSection';
import { OUTLINE_SMALL } from './buttonProps';

// Turns what the questions generated into editable parts, so any detail of the query can be changed.
export const CustomiseStep = () => {
  const [a, setA] = useRecoilState(builderAnswersState);
  const output = useRecoilValue(builderEffectiveOutputState);
  if (!output) return null;

  const customise = () => {
    const { builder: _builder, ...config } = output.config;
    const imported = importAdvanced(output.queryString, JSON.stringify(config), output.handlerKey);
    if (imported) setA({ ...a, recipe: 'advanced', ...imported, chart: resolvedChart(a) });
  };

  return (
    <BuilderSection title="Change the query itself (advanced)" hint="Turns what these questions generated into parts you can edit: every index, filter, aggregation and setting. The questions above are then replaced by the parts, so this cannot be undone for this KPI.">
      <Button {...OUTLINE_SMALL} onClick={customise}>
        Edit the query part by part
      </Button>
    </BuilderSection>
  );
};
